export const getSimpleMessageSx = (isCurrentUser?: boolean) => {
  const { bg, color, borderRadius } = isCurrentUser
    ? {
        bg: 'M.70',
        color: 'M.10',
        borderRadius: '4px 4px 0px 4px',
      }
    : {
        bg: 'M.20',
        color: 'M.70',
        borderRadius: '0px 4px 4px 4px',
      };

  return {
    containerSx: {
      position: 'relative',
      bg,
      border: 'none',
      borderRadius,
      p: 2,
      maxWidth: '256px',
      width: '100%',
    },
    textSx: {
      color,
      wordBreak: 'break-word',
      whiteSpace: 'pre-line',
    },
  };
};
